module.exports = __webpack_public_path__ + "static/media/IMG_1251-min.dabba961.jpg";